/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const BOOTSTRAP_CONFIG = {
  servers: {
    graphql: [
      {
        name: "graphql-gateway",
        devurl: "https://kiran.vlinderserver.online/tribe-v2/core/",
        staginurl: "https://ca-central-staging-1.klefki.io/tribe/core/",
        url: "https://ca-central-1.klefki.io/tribe/core/",
      },
    ],
    rest: {
      loginServer: {
        devbaseURL: "https://kiran.vlinderserver.online/tribe-v2/login",
        stagingbaseURL: "https://ca-central-staging-1.klefki.io/tribe/login",
        baseURL: "https://ca-central-1.klefki.io/tribe/login",
      },
    },
  },
};
